export default [
    {
      id: 105,
      person: "Carol J. Anderson",
      companyName: "Inc",
      department: "Tools",
      location: "East Chadburgh",
      phone: "60060",
      requiredExp: "4-7",
      type: "internship",
      candidates: 10,
      salary: "85-99",
      status: "rejected",
    },
    {
      id: 110,
      person: "Janean Cruze",
      companyName: "Inc",
      department: "Baby",
      location: "North Wilfrid",
      phone: "38990",
      requiredExp: "25-38",
      type: "consultant",
      candidates: 7,
      salary: "15-24",
      status: null,
    },
    {
      id: 115,
      person: "Agnus Brode",
      companyName: "Inc",
      department: "Tools",
      location: "Adrienborough",
      phone: "42411",
      requiredExp: "4-7",
      type: "Full time",
      candidates: 10,
      salary: "25-38",
      status: "accepted",
    },
    {
      id: 120,
      person: "Takako Zickefoose",
      companyName: "and Sons",
      department: "Automotive",
      location: "Natfort",
      phone: "32393-3089",
      requiredExp: "25-38",
      type: "consultant",
      candidates: 10,
      salary: "25-38",
      status: "rejected",
    },
    {
      id: 125,
      person: "Franklyn Miyamoto",
      companyName: "Inc",
      department: "Jewelery",
      location: "Kiehnport",
      phone: "71458-5793",
      requiredExp: "45-40",
      type: "Full time",
      candidates: 29,
      salary: "11-13",
      status: "rejected",
    },
    {
      id: 130,
      person: "Eusebio Florentino",
      companyName: "Inc",
      department: "Computers",
      location: "South Milfordburgh",
      phone: "97392-1632",
      requiredExp: "85-99",
      type: "internship",
      candidates: 8,
      salary: "25-38",
      status: "accepted",
    },
    {
      id: 135,
      person: "Celestina Driggs",
      companyName: "and Sons",
      department: "Automotive",
      location: "West Keithburgh",
      phone: "84992",
      requiredExp: "85-99",
      type: "internship",
      candidates: 15,
      salary: "25-38",
      status: null,
    },
    {
      id: 140,
      person: "Omega Swartz",
      companyName: "Inc",
      department: "Beauty",
      location: "Gregoriaview",
      phone: "80355-7777",
      requiredExp: "11-13",
      type: "internship",
      candidates: 14,
      salary: "11-13",
      status: "rejected",
    },
    {
      id: 145,
      person: "Ken Gurney",
      companyName: "and Sons",
      department: "Movies",
      location: "Izabellaland",
      phone: "92377-1778",
      requiredExp: "11-13",
      type: "internship",
      candidates: 5,
      salary: "11-13",
      status: "rejected",
    },
    {
      id: 150,
      person: "Thora Callaghan",
      companyName: "LLC",
      department: "Health",
      location: "Fionaville",
      phone: "03079",
      requiredExp: "4-7",
      type: "internship",
      candidates: 16,
      salary: "85-99",
      status: null,
    },
    {
      id: 155,
      person: "Elodia Mina",
      companyName: "LLC",
      department: "Home",
      location: "Angiestad",
      phone: "03241-1814",
      requiredExp: "85-99",
      type: "internship",
      candidates: 5,
      salary: "11-13",
      status: "rejected",
    },
    {
      id: 160,
      person: "Laverna Hiltner",
      companyName: "Inc",
      department: "Electronics",
      location: "East Alexandroport",
      phone: "81264",
      requiredExp: "7-10",
      type: "on-contract",
      candidates: 5,
      salary: "25-38",
      status: null,
    },
    {
      id: 165,
      person: "Melani Poyner",
      companyName: "and Sons",
      department: "Shoes",
      location: "Caylafurt",
      phone: "59461",
      requiredExp: "45-40",
      type: "internship",
      candidates: 6,
      salary: "4-7",
      status: "accepted",
    },
    {
      id: 170,
      person: "Huey Godsey",
      companyName: "LLC",
      department: "Home",
      location: "Mantebury",
      phone: "88101",
      requiredExp: "7-10",
      type: "Full time",
      candidates: 6,
      salary: "85-99",
      status: "accepted",
    },
    {
      id: 175,
      person: "Wally Perrone",
      companyName: "Group",
      department: "Shoes",
      location: "West Orrinfurt",
      phone: "93083-0224",
      requiredExp: "4-7",
      type: "Full time",
      candidates: 21,
      salary: "85-99",
      status: "rejected",
    },
    {
      id: 180,
      person: "Verlie Hilderbrand",
      companyName: "Group",
      department: "Computers",
      location: "South Mitchelmouth",
      phone: "64997-5741",
      requiredExp: "85-99",
      type: "Full time",
      candidates: 13,
      salary: "85-99",
      status: "rejected",
    },
    {
      id: 185,
      person: "Madge Mcdow",
      companyName: "and Sons",
      department: "Tools",
      location: "South Charlotte",
      phone: "19601",
      requiredExp: "4-7",
      type: "internship",
      candidates: 30,
      salary: "11-13",
      status: "accepted",
    },
    {
      id: 190,
      person: "Lead Branding Strategist",
      companyName: "Group",
      department: "Outdoors",
      location: "Vilmamouth",
      phone: "07913",
      requiredExp: "11-13",
      type: "on-contract",
      candidates: 5,
      salary: "25-38",
      status: null,
    },
    {
      id: 195,
      Person: "Lead Web Producer",
      companyName: "LLC",
      department: "Outdoors",
      location: "Spinkaview",
      phone: "17101-4987",
      requiredExp: "25-38",
      type: "Full time",
      candidates: 14,
      salary: "25-38",
      status: null,
    },
  ];
  
  